import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { RecordingListFeatureGate } from '../Guards/RecordingListFeatureGate'
import { RecordingList } from '../Components/Organisms/RecordingList/RecordingList'

/** Routed page shell for the Recording List admin view. */
@Route(RouteID.RECORDING)
export class RecordingListPage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.RECORDING}>
                <RecordingListFeatureGate>
                    <LanguageContextProvider>
                        <RecordingList />
                    </LanguageContextProvider>
                </RecordingListFeatureGate>
            </RouteGuard>
        )
    }
}
